import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import classNames from 'classnames';
import TextButton from '../../../../../elements-buttons/text-button';
import AddOnField from '../../fields/AddOnField/AddOnField';
import TextField from '../../fields/TextField/TextField';
import { injectIntl, intlShape } from 'react-intl';

class AddTaxes extends Component {
  constructor (props) {
    super(props);
    this.handleAddClick = this.handleAddClick.bind(this);
  }

  componentDidMount () {
    if (!this.props.addAddtlTaxes && 0 >= this.props.fields.length) {
      this.handleAddClick();
    }
  }

  handleAddClick (e) {
    if (e) { e.preventDefault(); }

    this.props.fields.push({
      charge_type: 'tax',
      charge_unit: '%'
    });
  }

  render () {
    const { classnames, fields, addAddtlTaxes, taxError } = this.props;
    return (
      <div
        className={classNames('add-taxes-component', classnames)}
        data-testing-id="add-taxes-component"
      >
        {
          fields.map((tax, index) => {
            return (
              <div className="tax-block" key={tax}>
                <Field
                  name={`${tax}.label`}
                  component={TextField}
                  className="margin-md-bottom"
                  placeholder={ this.props.intl.formatMessage({ id: 'inbox.add_taxes.name', defaultMessage: 'Tax name, i.e. Sales tax' }) }
                  errorMessage={ taxError ? null : this.props.intl.formatMessage({ id: 'inbox.add_taxes.enter_title', defaultMessage: 'Please enter a title' }) }
                  attributes={{ 'data-testing-id': 'tax-label-field' }}
                  isError={!!taxError}
                />
                <div>
                  <div className="flex space-between">
                    <Field
                      name={`${tax}.amount`}
                      fieldType="number"
                      component={AddOnField}
                      label="%"
                      className="tax-field"
                      attributes={{ 'data-testing-id': 'tax-amount-field' }}
                      isError={!!taxError}
                    />
                    <div className="flex-col-2" />
                  </div>
                  {taxError && <div className="help-block text-danger">
                    {taxError}
                  </div>}
                </div>
                { addAddtlTaxes &&
                  <div className="flex space-between margin-md-top">
                    <div>
                      {
                        (index === fields.length - 1) &&
                        <TextButton
                          onClick={this.handleAddClick}
                          buttonText={ this.props.intl.formatMessage({ id: 'inbox.add_taxes.add_more', defaultMessage: 'Add more' }) }
                          attributes={{ 'data-testing-id': 'add-more-taxes-button' }}
                          classNames="underline no-padding"
                        />
                      }
                    </div>
                    <TextButton
                      onClick={(e) => { e.preventDefault(); fields.remove(index); }}
                      buttonText={ this.props.intl.formatMessage({ id: 'inbox.add_taxes.remove', defaultMessage: 'Remove' }) }
                      icon="x"
                      attributes={{ 'data-testing-id': 'remove-tax-button' }}
                      classNames="underline no-padding"
                    />
                  </div> }
              </div>
            );
          })
        }

        {
          0 >= fields.length && addAddtlTaxes &&
          <div>
            <TextButton
              onClick={this.handleAddClick}
              buttonText={ this.props.intl.formatMessage({ id: 'inbox.add_taxes.add_tax', defaultMessage: '+ Add tax' }) }
              attributes={{ 'data-testing-id': 'add-tax-button' }}
              classNames="underline no-padding"
            />
          </div>
        }
      </div>
    );
  }
}

AddTaxes.propTypes = {
  classnames: PropTypes.string,
  fields: PropTypes.object,
  addAddtlTaxes: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(AddTaxes);
